// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgLockSquare = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.273 7.481C9.82 6.77 10.71 6.251 12 6.251s2.181.518 2.728 1.23c.52.677.689 1.473.689 2.02v1.75a1.35 1.35 0 0 1 1.333 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-6.8a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.74.595-1.342 1.334-1.35V9.5c0-.547.168-1.343.688-2.02m.812 3.77h3.832V9.5c0-.287-.098-.742-.377-1.106-.253-.33-.697-.645-1.539-.645s-1.285.315-1.538.645c-.28.364-.378.82-.378 1.105zm-1.334 1.5v3.5h6.5v-3.5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5c0-1.52 1.23-2.75 2.75-2.75h14c1.52 0 2.75 1.23 2.75 2.75v14c0 1.52-1.23 2.75-2.75 2.75H5c-1.52 0-2.75-1.23-2.75-2.75z"
      clipRule="evenodd"
    />
  </svg>
);
export const LockSquareIcon = forwardRef(SvgLockSquare);
